/**
 * Abre a vaga no app de mapas do dispositivo (Android: AndroidInterface.abrirMaps).
 */

export function montarTextoEnderecoVaga(vaga) {
	if (!vaga) return ""
	if (typeof vaga.enderecoTexto === "string" && vaga.enderecoTexto.trim()) {
		return vaga.enderecoTexto.trim()
	}
	const partes = []
	const log = [vaga.logradouro, vaga.numero].filter(Boolean).join(", ")
	if (log) partes.push(log)
	if (vaga.bairro) partes.push(String(vaga.bairro))
	const cidadeUf = [vaga.cidade, vaga.uf].filter(Boolean).join(" / ")
	if (cidadeUf) partes.push(cidadeUf)
	if (vaga.cep) partes.push(`CEP ${vaga.cep}`)
	return partes.join(" — ")
}

export function obterCoordenadasVaga(vaga) {
	const la = Number(vaga?.latitude ?? vaga?.la)
	const lo = Number(vaga?.longitude ?? vaga?.lo)
	if (!Number.isFinite(la) || !Number.isFinite(lo) || (la === 0 && lo === 0)) {
		return null
	}
	return { latitude: la, longitude: lo }
}

/**
 * @returns {boolean} true se abriu ou tentou abrir
 */
export function abrirVagaNoGps(vaga) {
	const coords = obterCoordenadasVaga(vaga)
	if (coords && window.AndroidInterface?.abrirMaps) {
		window.AndroidInterface.abrirMaps(`${coords.latitude},${coords.longitude}`)
		return true
	}

	const endereco = montarTextoEnderecoVaga(vaga)
	if (coords) {
		const url = `https://www.google.com/maps/dir/?api=1&destination=${coords.latitude},${coords.longitude}`
		window.open(url, "_blank", "noopener,noreferrer")
		return true
	}
	if (endereco) {
		const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`
		if (window.AndroidInterface?.redirectLink) {
			window.AndroidInterface.redirectLink(url)
			return true
		}
		window.open(url, "_blank", "noopener,noreferrer")
		return true
	}

	return false
}
